import React from 'react';
import { Link } from 'react-router-dom';
import { MdClose } from 'react-icons/md';

export default () => (
  <Link to="/" style={{ position: 'absolute', right: 20, top: 20, fontSize: 36, color: 'white' }}>
    <MdClose />
  </Link>
);
